/**
 * 头条列表的相关功能:
 *  调用列表加载公共js,
 *  添加【新】字样.
 * Created by huangxiaoli on 2016/8/11.
 * @require jquery-1.9.1
 */
// var NormalList = require('@cnpm/list/src/cms_list');
var RollList = require('./roll_list.js');
var RandomVideo = require('@cnpm/random-video');
var startmarquee = require('./startmarquee');
var computationTime = require('./computation-time');
var Sub = $({});

function checkFirstPageLoaded() {
  //Tab切换中当前的二级栏目
  var $cur = $('.qiehuanNav-new .cur');
  var oneloadstatus = parseInt($cur.data('oneloadstatus'), 10);
  var pageno;
  //首屏数据服务器端已渲染
  if (oneloadstatus === 1) {
    Sub.trigger('FirstPageLoaded', $cur);
    return;
  }

  //首屏数据客户端渲染
  pageno = parseInt($cur.data('oneloadstatus'), 10);
  if (pageno === 1) {
    Sub.trigger('FirstPageLoaded', [$cur]);
  }
}

Sub.bind('FirstPageLoaded', function FirstPageLoaded(e, cur) {
  //videochannel 属性：用于加载视频的频道key
  //videourl 属性：用于加载视频的URL
  //videoloaded属性：该tab是否加载过视频
  //页面元素需要配置的属性：配置二者配其一即可
  //如果同时配 videourl的优先级更高
  var $cur = $(cur);
  var channel = $cur.data('videochannel');
  var url = $cur.data('videourl');
  var loaded = $cur.data('videoloaded');
  //pageno = parseInt($cur.data('pageno'), 10);

  if ((loaded !== 1) && (channel || url)) {
    //加载视频数据
    RandomVideo.load({
      channel: channel, //频道，默认最新
      url: url,
      onload: function () {
        $(window).trigger('resize');
      }
    });
    $cur.data('videoloaded', 1);
  }
});

/**
 * 列表结构渲染成功后回调.
 */
function normalListCB() {
  //处理时间格式.
  computationTime.init($('.news-sum-time'), 'data-time');
  //Chinaso.ListStyle.cutImgsCallback($('.news-sum-img')); //样式切换图片裁切.
  // Chinaso.ListAdTuck.tuckAd(); //广告插入.
  $('.indexMain').trigger('main:resizeHeight');
  if(!window.isScroll && $('.qieHuan:eq(0)').is(':visible'))
  $('.footer_index').attr('style','position:static');
  window.isScroll = true;
}

/**
 * 【新】样式添加
 */
function addNewClass() {
  var $time = $('.news-sum-time');
  var $con = $('.news_index_v1_con_list_con').eq(0);
  var arrTime = [];
  var i = 0; var $cur; var time; var newStr;
  var arr; var datum; var publishTime;
  var len = $time.length;
  var j = 0; var idx;
  if (len) {
    for (i; i < len; i += 1) {
      $cur = $time.eq(i);
      time = $cur.data('time');
      newStr = time.replace(/:/g, '-');
      newStr = newStr.replace(/ /g, '-');
      arr = newStr.split('-');
      datum = new Date(Date.UTC(arr[0], arr[1] - 1, arr[2], arr[3] - 8, arr[4], arr[5]));
      publishTime = datum.getTime();
      arrTime.push({
        idx: i,
        time: publishTime
      });
    }
    //将得到的时间数组排序.
    arrTime.sort(function (a, b) {
      return b.time - a.time;
    });
    //把时间数组中前排在前三条的数据前面加上【新】标签.
    // for (; j < 3; j += 1) {
    //   idx = arrTime[j].idx;
    //   $con.find('.news-sum-list>div').eq(idx).find('h3').prepend('<span class="icon-new">新</span>');
    // }
  }
}

/**
 * 函数调用.
 */
function listPowerNice() {
  // var normalList;
  //第一页数据时间格式处理.
  // computationTime.init($('.news-sum-time'), 'data-time');
  // Chinaso.MoreNavs.init(true, false, normalListCB);//滚动加载更多方法调用.
  // normalList = new NormalList($('.qiehuanNav-new li').eq(0), $('.qieHuanCont .listnews').eq(0), false, normalListCB);
  // normalList.init();
  window.newsList.cb = normalListCB;
  var rollList = new RollList(window.newsList);
  rollList.init();
  this.rollList = rollList;
  // rollList.send();
  //快讯滚动交互添加.
  startmarquee(30, 30, 4000);
  checkFirstPageLoaded();
  addNewClass();
}

module.exports = listPowerNice;



//////////////////
// WEBPACK FOOTER
// ./static/v4/js/list_power_nice.js
// module id = f478ad03140395084ac0
// module chunks = 1